import EntityModel from '@/common/models/entity-model';

export default class OrderCancellationModel extends EntityModel {
    static CancelEntities = {
        customer: 'customer',
        merchant: 'merchant',
    };

    static Reasons = {
        billingFailure: 'billing-failure',
        bugsOrProblems: 'bugs-or-problems',
        contractExpired: 'contract-expired',
        didNotUse: 'did-not-use',
        didNotWant: 'did-not-want',
        doNotRemember: 'do-not-remember',
        missingFeatures: 'missing-features',
        other: 'other',
        riskWarning: 'risk-warning',
        tooExpensive: 'too-expensive',
    };

    static Statuses = {
        draft: 'draft',
        confirmed: 'confirmed',
        completed: 'completed',
        revoked: 'revoked',
    };

    hydrate({
        id = null,
        subscriptionId = null,
        canceledBy = OrderCancellationModel.CancelEntities.customer,
        reason = OrderCancellationModel.Reasons.other,
        description = null,
        prorated = false,
        status = OrderCancellationModel.Statuses.confirmed,
        churnTime = null,
        lineItems = [],
    } = {}) {
        this.id = id;
        this.subscriptionId = subscriptionId;
        this.canceledBy = canceledBy;
        this.reason = reason;
        this.description = description;
        this.prorated = prorated;
        this.status = status;
        this.churnTime = churnTime;
        this.lineItems = lineItems;
    }

    getPayload() {
        return {
            subscriptionId: this.subscriptionId,
            canceledBy: this.canceledBy,
            reason: this.reason,
            description: this.description,
            prorated: this.prorated,
            status: this.status,
            churnTime: this.churnTime,
            lineItems: this.lineItems,
        };
    }
}
